/**
 * The order the individual measurements are listed in, and the page of them
 * currently on screen.
 *
 * Paging is done over what has already been fetched rather than by asking the
 * server again: the read brings back the window's measurements in one request,
 * so changing the page size rearranges the page instead of blanking it while a
 * request goes out.
 *//**
 * Newest-first, or slowest-first.
 *
 * Newest-first is the default because the usual question is "what is it doing
 * now"; slowest-first is the one for "show me the bad ones", and a measurement
 * that never ended sorts to the top of it because a call that never returned
 * is worse than any call that merely took a while.
 */export function orderRecords(records,slowestFirst){if(!slowestFirst){return records;}return[...records].sort((left,right)=>{var _right$durationMs,_left$durationMs;return((_right$durationMs=right.durationMs)!==null&&_right$durationMs!==void 0?_right$durationMs:Number.POSITIVE_INFINITY)-((_left$durationMs=left.durationMs)!==null&&_left$durationMs!==void 0?_left$durationMs:Number.POSITIVE_INFINITY);});}/**
 * One page of the list.
 *
 * The page index is clamped rather than reset: changing the window or the
 * ordering can shrink the list under the reader's feet, and landing on an
 * empty page reads as a failure rather than as the end of the list.
 */export function pageOf(listed,pageSize,page){const pageCount=Math.max(Math.ceil(listed.length/pageSize),1);const currentPage=Math.min(Math.max(page,0),pageCount-1);return{currentPage,pageCount,visible:listed.slice(currentPage*pageSize,currentPage*pageSize+pageSize)};}/**
 * The bounds the duration column is colored against.
 *
 * This page and no further. Scaling over every fetched measurement would leave
 * a page of near-identical readings colored by an extreme that is nowhere on
 * screen — the reader would be comparing against something they cannot see.
 */export function heatBounds(records){const durations=[];for(const record of records){if(record.durationMs!=null){durations.push(record.durationMs);}}if(durations.length===0){return{fastestMs:0,slowestMs:0};}return{fastestMs:Math.min(...durations),slowestMs:Math.max(...durations)};}